import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import { useRecipeLikes } from "@/hooks/useRecipeLikes";

type CardLikeButtonProps = {
  recipeId: number;
  needsTotalLikeCount: boolean;
  recipeTitle: string;
};

export const CardLikeButton = ({
  recipeId,
  needsTotalLikeCount,
  recipeTitle,
}: CardLikeButtonProps) => {
  const { userLikedRecipe, handleLike } = useRecipeLikes(
    recipeId,
    needsTotalLikeCount,
  );
  const { getIcon, getLabel } = useGlobalContext();

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        handleLike();
      }}
      style={{ position: "relative", zIndex: 3 }}
      aria-label={
        userLikedRecipe
          ? getLabel("aria_label_recipe_remove_favorite").replace(
              "$$title",
              recipeTitle,
            )
          : getLabel("aria_label_recipe_add_favorite").replace(
              "$$title",
              recipeTitle,
            )
      }
    >
      <ReactSVG
        src={getIcon(userLikedRecipe ? "heartFilled" : "heartEmpty")}
        height={29}
        width={34}
        wrapper="svg"
        aria-hidden
      />
    </button>
  );
};
